import { HiX } from 'react-icons/hi';
import { useBoolean } from 'usehooks-ts';

import GoogleAd from '../GoogleAd';

interface BannerProps {
  handset?: boolean;
  web?: boolean;
}
const HorizontalBannerAd: React.FC<BannerProps> = ({ handset, web }) => {
  const { value: googleAdClosed, setTrue: closeGoogleAd } = useBoolean(false);

  return (
    <>
      {web && !googleAdClosed && (
        <div
          aria-hidden
          tabIndex={-1}
          className="absolute w-full aspect-1000/300 max-w-[1000px] mx-auto mb-1 overflow-hidden hidden lg:block bg-transparent rounded-2xl"
        >
          <button
            tabIndex={-1}
            className="p-1 rounded-full bg-gray-100 text-gray-600 absolute top-3 left-4 border border-gray-300 "
            onClick={closeGoogleAd}
          >
            <HiX size={19} />
          </button>
          <span className="py-0.5 px-2 text-xs rounded-full bg-gray-100 text-gray-600 border border-slate-300 absolute flex justify-center top-4 left-14 mr-14">
            Publicité
          </span>
          <GoogleAd
            ad={{
              slot: '/118262226/C1_Desktop_1000x300',
              mapping: {
                0: [1000, 300],
              },
              sizes: [[1000, 300]],
            }}
            className={'w-full h-full overflow-hidden'}
          />
        </div>
      )}

      {handset && !googleAdClosed && (
        <div
          aria-hidden
          tabIndex={-1}
          className="absolute h-[100px] w-[320px] flex items-center  mx-auto  overflow-hidden lg:hidden bg-transparent rounded-2xl"
        >
          <button
            tabIndex={-1}
            className="p-1 rounded-full bg-gray-100 text-gray-600 absolute top-1 left-1 border border-gray-300 "
            onClick={closeGoogleAd}
          >
            <HiX size={19} />
          </button>

          <GoogleAd
            ad={{
              slot: '/118262226/C1_Mobile_320x100',
              mapping: {
                0: [320, 100],
              },
              sizes: [[320, 100]],
            }}
            className={'sm:hidden mx-auto h-[100px] w-[320px] overflow-hidden'}
          />
        </div>
      )}
    </>
  );
};

export default HorizontalBannerAd;
